import React from 'react';

import { Avatar as AvatarComponent } from '../../Avatar';
import { Button } from '../../Button';

function Avatar({ username, onClickAvatar }: { username: string; onClickAvatar?: (event: any) => void }) {
    const onClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (onClickAvatar) {
            onClickAvatar(event);
        }
    };

    return (
        <Button theme="toggle" style={{ width: '60px' }} className="h-100 px-l border-0 rounded-0" onClick={onClick}>
            <AvatarComponent name={username} />
        </Button>
    );
};

export default Avatar;